<ng-container *ngFor="let cascadeMenu of cascadeMenus;let i = index">
    <maced-cascade-menubar [cascadeMenubarId]="'CascadeMenubar' + i" [cascadeMenubarLabel]="cascadeMenu.name"
      [cascadeMenuList]="cascadeMenu.menus" *ngIf="cascadeMenu.isVisible" 
      [hasTitleBar]="true" [hasBreadcrumbs]="true" [backUrl]="'../navigation-drawer-case1'" [backQueryParams]="{menuHierarchy:'0_0_1',showMenu:true}">
      <ng-container ngProjectAs="[breadcrumbsPanel]">
        <maced-breadcrumbs [id]="breadcrumbsContainer" [linksData]="breadcrumbsName"
          [isLinksClickable]="isLinksClickable" [nextIconClass]="nextIconClass"
          [numberOfLinksVisible]="numberOfLinksVisible" [breadCrumbLimit]='breadCrumbLimit'>
        </maced-breadcrumbs>
      </ng-container>
    </maced-cascade-menubar>
</ng-container>
<p>Sample-Module-For-Navigation-Drawer !</p>
